import technologyService from "../../services/technologyService/service";
import technologyModel from "../../models/technologyModel/model";
export default {
    async fetchTechnology(search, page, limit, company) {
        try{
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const {data, headers} = await technologyService.getTechnology(sanitizedSearch, page, limit, company);
            return {
                data: data.map(technology => new technologyModel(technology)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            };
        } catch (error) {
            console.error('Error fetching technologies:', error);
            return {
                data: [],
                total: 0,
            };
        }
    },
    async totalAllTechnology(company) {
        try{
            return await technologyService.totalAllTechnology(company);
        } catch (error) {
            console.error('Error fetching technologies:', error);
        }
    },
    async addTechnology(technology) {
        try {
            return await technologyService.addTechnology(technology);
        } catch (error) {
            console.error('Error adding technology:', error);
            throw error;
        }
    },
    async updateTechnology(technology) {
        try {
            return await technologyService.updateTechnology(technology);
        } catch (error) {
            console.error('Error updating technology:', error);
            throw error;
        }
    },
    async deleteTechnology(technologyId) {
        try {
            return await technologyService.deleteTechnology(technologyId);
        } catch (error) {
            console.error('Error deleting technology:', error);
            throw error;
        }
    },
}